import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { ContactIdCompanyPair } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

function contactToContactIdCompanyPair(contact: ContactSearchEntry): ContactIdCompanyPair {
    return {
        contactId: contact.id,
        prospect: contact.site,
    };
}

export default contactToContactIdCompanyPair;
